import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { Tax } from '../../interfaces/Tax/Tax';
import { getTaxes } from '../../api/Tax';
import { sharedColors } from '../../utils/Style';

interface TaxDropdownProps {
  label?: string;
  taxID?: number;
  onChange: (id?: number) => void;
}

export const TaxDropdown = (props: TaxDropdownProps) => {
  const [loading, setLoading] = useState(false);
  const [taxes, setTaxes] = useState<Tax[]>([]);

  useEffect(() => {
    setLoading(true);
    getTaxes()
      .then((t) => setTaxes(t))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1.5,
        alignItems: 'center',
      }}
    >
      <FormControl size='small' fullWidth>
        {!!props.label && <InputLabel>{props.label}</InputLabel>}
        <Select
          label={props.label}
          value={props.taxID ?? -1}
          onChange={(e) => {
            const newID = Number(e.target.value);
            props.onChange(Number.isFinite(newID) ? newID : undefined);
          }}
        >
          <MenuItem value={-1}>
            <Typography sx={{ fontStyle: 'italic', color: sharedColors.gray5 }}>
              {'<YOK>'}
            </Typography>
          </MenuItem>
          {taxes.map((tax) => (
            <MenuItem key={tax.id} value={tax.id}>
              {`${tax.title} (%${tax.multiplier.toFixed(2)})`}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {loading && <CircularProgress size={24} />}
    </Box>
  );
};
